const initBlock = async function( $block ) {
	const $filters = $block.find( '.blog-filters' );
	if ( $filters.length === 0 ) { return false; }

	const BlogFiltersModule = await import( '../modules/blog-filters' );
	const BlogFilters = BlogFiltersModule.default;
	// eslint-disable-next-line no-unused-vars
	const filters = new BlogFilters( $filters );
};

app.loadBlock( initBlock, 'section-blog', '.section-blog' );

if ( module.hot ) {
	module.hot.accept();
}
